import Icon from './squareLogo.svg?react';
import classes from './Logo.module.css';

type Props = {
  onClick?: () => void;
};

export default function SquareLogo({ onClick }: Props) {
  return <Icon className={classes.logoClickable} onClick={onClick} height={32} width={32} />;
}
